'use strict';

var React = require('react');

var SvgOrderStatusMinor = function SvgOrderStatusMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 7a1 1 0 1 1 0-2h2.586l2.707-2.707a.997.997 0 0 1 1.655.391l1.49 4.465 1.855-1.856a.996.996 0 0 1 .707-.293h3a1 1 0 1 1 0 2h-2.586l-2.707 2.707a.998.998 0 0 1-1.655-.391l-1.49-4.465-1.855 1.856a.996.996 0 0 1-.707.293h-3zm14 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v3h2.382c.379 0 .725.214.894.553l.724 1.447h4l.724-1.447a.998.998 0 0 1 .894-.553h2.382v-3a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9h2v1h-2zm14 0h2v1h-2z"
  }));
};

exports.SvgOrderStatusMinor = SvgOrderStatusMinor;
